import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
 import "./fetchPatch";
import "./styles/index.scss";
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './utils/language/i18n';
import "./apiBoot"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <HelmetProvider>
    <BrowserRouter>
    <App />
    </BrowserRouter>
 </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

